import axiosAPI from '../axiosAPI';

/**
 * Service para gerenciar cupons de desconto
 */
export const couponService = {
  /**
   * Validar cupom de desconto
   * @param {string} couponCode - Código do cupom
   * @param {number} planId - ID do plano
   * @returns {Promise} Dados do cupom e pricing
   */
  async validateCoupon(couponCode, planId) {
    const response = await axiosAPI.post('/subscriptions/validate-coupon', {
      coupon_code: couponCode,
      plan_id: planId
    });
    return response.data;
  }
};
